import React from 'react'
import { Flex, FlexProps, Spinner, SpinnerProps } from '@chakra-ui/react'

type Props = {
  isLight?: boolean
  size?: SpinnerProps['size']
} & FlexProps

export const Loader: React.FC<Props> = ({ isLight = false, size = 'xl', ...flexProps }) => (
  <Flex width="100%" justifyContent="center" marginY="50px" {...flexProps}>
    <Spinner size={size} color={isLight ? 'white' : 'green.a200'} />
  </Flex>
)
